import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_ctx.visible)
    ? (_openBlock(), _createBlock(_component_q_btn, {
        key: 0,
        size: "sm",
        style: {"min-width":"65px","width":"auto"},
        class: "q-mr-xs btn-brand",
        dense: "",
        color: _ctx.computedColor,
        label: _ctx.computedLabel
      }, {
        default: _withCtx(() => [
          (_ctx.tooltip)
            ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tooltip), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["color", "label"]))
    : _createCommentVNode("", true)
}